/**
 * https://redux.js.org/docs/recipes/ReducingBoilerplate.html#generating-reducers
 *
 * @param  {Object} initialState
 * @param  {Object} handlers
 * @return {function} - reducer
 */
export default function createReducer(initialState, handlers) {
    return function reducer(state = initialState, action) {
        if ({}.hasOwnProperty.call(handlers, action.type)) {
            return handlers[action.type](state, action);
        } else {
            return state;
        }
    };
}
